import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

// Renders a sequence of labels as connected, numbered nodes — an
// infographic "flow" instead of an arrow-joined sentence or a plain list.
export const FlowDiagram = ({ steps, dark = false, accentSolidBg = "bg-navy-900", accentText = "text-gold-400" }) => (
  <div className="flex flex-wrap items-center gap-y-3">
    {steps.map((step, i) => (
      <div key={step} className="flex items-center">
        <motion.span
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, margin: "-60px" }}
          transition={{ duration: 0.4, delay: i * 0.06 }}
          className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-semibold md:text-sm ${
            dark ? "border-white/15 bg-white/5 text-white" : "border-navy-900/10 bg-white text-navy-800 shadow-[0_4px_12px_rgba(0,0,0,0.04)]"
          }`}
        >
          <span className={`grid h-5 w-5 shrink-0 place-items-center rounded-full text-[10px] font-bold ${dark ? `${accentSolidBg} ${accentText}` : `${accentSolidBg} ${accentText}`}`}>
            {i + 1}
          </span>
          {step}
        </motion.span>
        {i < steps.length - 1 && <ArrowRight className={`mx-1.5 h-3.5 w-3.5 shrink-0 ${dark ? "text-white/30" : "text-navy-900/20"}`} />}
      </div>
    ))}
  </div>
);
